import { compose, lifecycle, withProps, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';

import RichSelect from '../RichSelect/RichSelect';
import { replacementModelsByIds } from '../../../entities/ReplacementModel/selectors';
import { agreementById } from '../../../entities/Agreement/selectors';
import { withFetch } from '../../../entities/Entity/containers';
import { Endpoints } from '../../../lib/LeanLinkService';
import { withTranslation } from 'react-i18next';

const entityToValue = replacementModel => ({
  value: replacementModel.id,
  label: `${replacementModel.name} ${replacementModel.archived ? ' - arkiverad' : ''}`,
});

const withAgreement = connect((state, { agreementId }) => (
  {
    agreement: agreementById(state, agreementId),
  }
));

const withReplacementModels = connect((state, { agreement, includeArchived }) => {
  if (!agreement || !agreement.replacementModels) {
    return {
      options: [],
    };
  }

  if (includeArchived) {
    return {
      options: replacementModelsByIds(state, agreement.replacementModels.toJS())
        .map(entityToValue),
    };
  }

  return {
    options: replacementModelsByIds(state, agreement.replacementModels.toJS())
      .filter(({ archived }) => !archived)
      .map(entityToValue),
  };
});

export default compose(
  withTranslation(),
  branch(({ agreementId }) => agreementId,
    compose(
      withProps((props) => ({
        placeholder: props.t('Välj prislista'),
      })),
      withFetch({
        props: ({ agreementId, ...props }) => ({
          ...props,
          agreementId,
          fetch: () => props.fetch({
            // Stays on v1 heavy on purpose. The booking-create + booking-view
            // flows read `replacementModel.periods` straight off the entity
            // store after the user picks a source pricelist; routing this
            // through the slim endpoint would leave periods undefined and
            // crash `hasBigWeekend` etc. The agreement-edit screen's own
            // lazy-load (per-RM fetch on accordion expand) still applies on
            // top of whichever variant landed first.
            url: Endpoints.agreements.get({ id: agreementId }),
          }),
        }),
      }),
      lifecycle({
        componentWillMount() {
          this.props.fetch();
        },
        componentWillReceiveProps(nextProps) {
          if (this.props.agreementId !== nextProps.agreementId) {
            nextProps.fetch();
          }
        },
      }),
      withAgreement,
      withReplacementModels,
      branch(
        ({ removedReplacementModelsIds }) =>
          removedReplacementModelsIds && removedReplacementModelsIds.size > 0,
        withProps(({ options, removedReplacementModelsIds }) => ({
          options: options.filter(o => !removedReplacementModelsIds.contains(o.value)),
        })),
      ),
    ),
    compose(
      renderNothing,
    ),
  ),
)(RichSelect);
